import React from 'react';

const PersonalPart = () => {
  return (
    <div className="personal">
      <div className="pricing__item">
        <div className="pricing__header">
          <div className="pricing__title">
            <h1 className="pricing__h">Self Employed</h1>
            <div className="pricing__badge is--pro">
              <div>Popular</div>
            </div>
          </div>
        </div>
        <div className="pricing__price">
          <h2 className="h2-2 is--price">$9.99</h2>
          <div className="price-yr">/month</div>
          <div className="text-m is--price">
            <span className="is--dimmed">or </span>
            <span className="is--bold">$99.99</span>
            <span className="is--dimmed"> /year</span>
          </div>
        </div>
        <div className="pricing__features">
          <div className="features-list">
            <div className="feature-item">
              <img src="img/checkbox.svg" loading="lazy" alt="" className="feature-checkbox" />
              <div className="text-l is--dimmed">Automatic Mileage Tracking</div>
            </div>
            <div className="feature-item">
              <img src="img/checkbox.svg" loading="lazy" alt="" className="feature-checkbox" />
              <div className="text-l is--dimmed">Work Hours Tracking</div>
            </div>
            <div className="feature-item">
              <img src="img/checkbox.svg" loading="lazy" alt="" className="feature-checkbox" />
              <div className="text-l is--dimmed">Document Capturing</div>
            </div>
            <div className="feature-item">
              <img src="img/checkbox.svg" loading="lazy" alt="" className="feature-checkbox" />
              <div className="text-l is--dimmed">Automatic Invoice Generation</div>
            </div>
            <div className="feature-item">
              <img src="img/checkbox.svg" loading="lazy" alt="" className="feature-checkbox" />
              <div className="text-l is--dimmed">Reports</div>
            </div>
            <div className="feature-item">
              <img src="img/checkbox.svg" loading="lazy" alt="" className="feature-checkbox" />
              <div className="text-l is--dimmed">QBO Integration</div>
            </div>
          </div>
        </div>
        <div className="pricing__cta">
          <button id="getstart2" className="button is--pricing w-inline-block">
            <div>Get Started</div>
          </button>
        </div>
      </div>
    </div>
  );
};

export default PersonalPart; 